import url from 'url';
import { get } from 'lodash';

import { ACTION_PREFIX, CARRIER } from '../../constants';
import { popularPlansSelector } from './popularPlansSelector';
import { carrierSelector } from '../carriers';
import dropdownStateSelector from '../dropdown-state/dropdownStateSelector';

export const REQUEST_POPULAR_PLANS = `${ACTION_PREFIX}/REQUEST_POPULAR_PLANS`;
export const REQUEST_POPULAR_PLANS_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_POPULAR_PLANS_SUCCEEDED`;

const apiUrl = url.parse(process.env.API_HOST || '');

function requestPopularPlans(carrierId) {
    return {
        type: REQUEST_POPULAR_PLANS,
        payload: {
            carrierId,
        },
    };
}

function requestPopularPlansSucceeded(carrierId, plans) {
    return {
        type: REQUEST_POPULAR_PLANS_SUCCEEDED,
        payload: {
            carrierId,
            plans,
        },
    };
}

function fetchPopularPlans(state) {
    return dispatch => {
        const carrierId = carrierSelector(state);
        dispatch(requestPopularPlans(carrierId));
        return (
            fetch(
                url.format({
                    protocol: apiUrl.protocol,
                    host: apiUrl.host,
                    pathname: `/api/1/carriers/${carrierId}/plans`,
                    query: {
                        tier: 1,
                    },
                }),
                {
                    credentials: 'same-origin',
                }
            )
                .then(response => response.json())
                .then(json => {
                    dispatch(requestPopularPlansSucceeded(carrierId, json.plans));
                })
                // eslint-disable-next-line no-console
                .catch(err => console.error(err))
        );
    };
}

export function fetchPopularPlansIfNeeded(forceFetch) {
    return (dispatch, getState) => {
        const state = getState();
        const carrierId = carrierSelector(state);
        const plans = popularPlansSelector(state);
        if (!!carrierId && carrierId !== CARRIER.ILL_CHOOSE_LATER && (forceFetch || !plans)) {
            return dispatch(fetchPopularPlans(state));
        }
    };
}

// This is called via the dropdownStateActions in the insurance picker, when the dropdown opens on click
export function fetchPopularPlansIfNeededDropdown(forceFetch) {
    return (dispatch, getState) => {
        const state = getState();
        const selector = dropdownStateSelector(state);
        const carrierId = get(selector, 'carrier.id');
        const plans = popularPlansSelector(state);
        if (!!carrierId && carrierId !== CARRIER.ILL_CHOOSE_LATER && (forceFetch || !plans)) {
            return dispatch(fetchPopularPlans(state));
        }
    };
}
